const formatCartCountLabel = (count) => {
  const templates = window.theme?.strings?.cartCount;
  if (!templates) {
    return count === 1 ? `(${count} item)` : `(${count} items)`;
  }
  const tpl = count === 1 ? templates.one : templates.other;
  return `(${tpl.replace(/\{\{\s*count\s*\}\}/g, String(count))})`;
};

const formatCartViewSr = (count) => {
  const tpl = window.theme?.strings?.cartView;
  if (!tpl) return '';
  return tpl.replace(/@@COUNT@@/g, String(count));
};

const updateCartCount = (count) => {
  const n = Number(count) || 0;

  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = n;
  });

  document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
    el.textContent = formatCartCountLabel(n);
  });

  document.querySelectorAll('[data-cart-count-sr]').forEach((el) => {
    el.textContent = formatCartViewSr(n);
  });
};

export default updateCartCount;
